import { workerTypes, getWorkerType } from "_src/engine/ipc.js";
import output from "_src/engine/output";
import config from "_src/config";

import { spawn, Worker, Thread } from "threads"

const _workersCounter = {};
const MAX_WORKER_COUNTER = {};
let _id = 0;

function createWorker(type) {

  let worker = null;

  switch (type) {
    case workerTypes.CORTO_PARSER:

      worker = new Worker("./loaders/corto/corto_worker.js");
      break;

    case workerTypes.ZSTD_PARSER:

      worker = new Worker("./loaders/zstd/zstd_worker.js");

      break;

    case workerTypes.GEOMETRY_PROCESSOR:

      worker = new Worker("./geometry_worker.js");
      break;

    case workerTypes.WASM_PROCESSOR:

      // todo: remove until fix default export from wasm_module
      worker = null;
      break;

    case workerTypes.PLY_PARSER:
      worker = new Worker("./loaders/external/ply/ply_worker.js");
      break;

    case workerTypes.OBJ_PARSER:
      worker = new Worker("./loaders/external/obj/obj_worker.js");
      break;

    case workerTypes.STL_PARSER:
      worker = new Worker("./loaders/external/stl/stl_worker.js");
      break;

    case workerTypes.USD_PARSER:
      worker = new Worker("./loaders/external/usd/usd_worker.js");
      break;

    default:
      output.error(output.DEVELOPERS_ERROR, "Can't create a worker. Unknown type: \"" + type + "\"");
      return null;
  }

  const spawnPromise = spawn(worker, {timeout: 200000}).catch((error) => {
    output.warn("Can't spawn worker: " + error);
    --_workersCounter[type];
    return null;
  });

  ++_workersCounter[type];

  return {
          type,
          number: _id++,
          spawnPromise
        };
}

export default {

  _workers : {},

  init : function () {

    MAX_WORKER_COUNTER[workerTypes.CORTO_PARSER] = config.maxWorkersPerTask;
    MAX_WORKER_COUNTER[workerTypes.ZSTD_PARSER] = config.maxWorkersPerTask;
    MAX_WORKER_COUNTER[workerTypes.GEOMETRY_PROCESSOR] = config.maxWorkersPerTask;
    MAX_WORKER_COUNTER[workerTypes.WASM_PROCESSOR] = 1;
    MAX_WORKER_COUNTER[workerTypes.PLY_PARSER] = 1;
    MAX_WORKER_COUNTER[workerTypes.OBJ_PARSER] = 1;
    MAX_WORKER_COUNTER[workerTypes.STL_PARSER] = 1;
    MAX_WORKER_COUNTER[workerTypes.USD_PARSER] = 1;

    for (let type in workerTypes) {

      const workerType = workerTypes[type];
      this._workers[workerType] = [];
      _workersCounter[workerType] = 0;

    }

  },

  getWorker : function(type) {

    const workerType = getWorkerType(type);

    if (!this._workers[workerType]) {
      this._workers[workerType] = [];
    }

    const workers = this._workers[workerType];

    if (_workersCounter[workerType] < MAX_WORKER_COUNTER[workerType]) {
      const worker = createWorker(workerType);
      if (worker !== null) {
        workers.push(worker);
      }
    }

    const worker = workers.length ? workers.pop() : null;

    return worker;

  },

  returnWorker : function(type, worker) {

    const workerType = getWorkerType(type);

    this._workers[workerType].push(worker);

  },

  getFreeWorkersCounter : function(type) {

    const workerType = getWorkerType(type);

    return this._workers[workerType].length;

  },

  cleanup : function (workerType) {

    const promises = [];
    const workers = this._workers[workerType];

    for (let i = 0; i < workers.length; ++i) {
      promises.push(workers[i].spawnPromise.then((worker) => {
        return Thread.terminate(worker);
      }));
    }

    workers.length = 0;

    _workersCounter[workerType] = 0;

    return Promise.all(promises);

  },

  getWorkerCounter(workerType) {
    return this._workers[workerType].length;
  }

};
